import { Dialog, DialogTitle, Button, Grid, Box, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import CenteredLoadingSpinner from "../../../components/CenteredLoadingSpinner";
import { TagBubble } from "../../../components/TagBubble";

import { Tag, TagType } from "../../../entities/customer/Tag";
import { TagService } from "../../../services/customer/TagService";
import { LinkButton } from "../../../components/LinkButton";
import { routes } from "../../../routes";

interface SelectTagDialogProps {
	open: boolean;
	disableTags: Tag[];
	type: TagType;
	onClose: () => void;
	onTagSelected: (tag: Tag) => void;
}

export function SelectTagDialog(props: SelectTagDialogProps) {
	const { disableTags, open, type } = props;
	const [tags, setTags] = React.useState<Tag[]>();
	const selectableTags = tags?.filter((t) => t.type === type);

	useEffect(() => {
		async function fetchTags() {
			const result = await TagService.getAll();
			if (result.success) {
				setTags(result.data);
			}
		}
		if (open) fetchTags();
	}, [open]);

	const onClose = () => {
		props.onClose();
	};

	return (
		<Dialog open={props.open} onClose={onClose} maxWidth="sm">
			<DialogTitle>Select Tag</DialogTitle>
			<Box p={2}>
				{!selectableTags ? (
					<CenteredLoadingSpinner />
				) : (
					<Grid container spacing={2}>
						{selectableTags.map((tag) => (
							<Grid item key={tag.id}>
								<TagBubble tag={tag} onClick={props.onTagSelected} disabled={disableTags.some((t) => t.id === tag.id)} />
							</Grid>
						))}
						{selectableTags.length === 0 && (
							<Grid item xs={12}>
								<Typography variant="body1">
									No tags available. You can create new tags by clicking the "Manage Tags" button below.
								</Typography>
							</Grid>
						)}
						<Grid item xs={12}>
							<Grid container justify="space-between" alignItems="center" spacing={1}>
								<Grid item>
									<LinkButton to={routes.app.resolve.tagsPage()} variant="outlined" color="primary">
										Manage Tags
									</LinkButton>
								</Grid>
								<Grid item>
									<Button variant="outlined" onClick={props.onClose}>
										Cancel
									</Button>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				)}
			</Box>
		</Dialog>
	);
}
